import {
  PERMISSIONS,
  PermissionStatus,
  check,
  checkMultiple,
} from 'react-native-permissions';
import {PermissionsAndroid, Platform} from 'react-native';

import {getOs} from '@buncha/utils/appInfo';
import {permissionRequiredStatuses} from '@buncha/config/utils/constants';

export const checkBluetoothPermissions = async (): Promise<boolean> => {
  try {
    let statuses: PermissionStatus[];
    const androidAPILevel = Platform.Version;

    if (androidAPILevel < '31') return true;

    if (getOs() === 'ios') {
      const permissionStatus = await check(
        PERMISSIONS.IOS.BLUETOOTH_PERIPHERAL,
      );
      statuses = [permissionStatus];
    } else {
      const permissionStatuses = await checkMultiple([
        PERMISSIONS.ANDROID.BLUETOOTH_CONNECT,
        PERMISSIONS.ANDROID.BLUETOOTH_SCAN,
      ]);
      statuses = Object.values(permissionStatuses);
    }

    return statuses.every(permsion => permsion === 'granted');
  } catch (error) {
    return false;
  }
};

export const requestBluetoothPermissions = async (): Promise<boolean> => {
  try {
    const androidAPILevel = Platform.Version;

    if (androidAPILevel >= '31') {
      const granted = await PermissionsAndroid.requestMultiple([
        PermissionsAndroid.PERMISSIONS.BLUETOOTH_CONNECT,
        PermissionsAndroid.PERMISSIONS.BLUETOOTH_SCAN,
      ]);
      const isGranted = Object.values(granted).every(status =>
        permissionRequiredStatuses.includes(status),
      );
      return isGranted;
    }
    return true;
  } catch (error) {
    return false;
  }
};
